import { api } from 'tools/api-service';
import { AxiosResponse } from 'axios';
import { GetArticlesBySection } from './types';

export const getSearch = async (
	term: string
): Promise<AxiosResponse<GetArticlesBySection>> => {
	const response = await api.get(`/helpcentre/search?term=${encodeURIComponent(term)}`);

	return response;
};
